<div class="footer-wrapper bg-transparent sticky bottom-0">
    <div class="footer">
        <div>© Siemens AG {{ year }}</div>
        <a class="footer-link" [href]="'footer.url.legal' | translate" target="_blank">
           {{ 'footer.corporate-information' | translate }} 
        </a>
        <a class="footer-link" [href]="'footer.url.privacy-notice' | translate" target="_blank">
           {{ 'footer.privacy-notice' | translate }} 
        </a>
        <a class="footer-link" [href]="'footer.url.cookie-notice' | translate" target="_blank">
           {{ 'footer.cookie-notice' | translate }} 
        </a>
        <a class="footer-link" [href]="'footer.url.terms-of-use' | translate" target="_blank">
           {{ 'footer.terms-of-use' | translate }} 
        </a>
        <a class="footer-link" [href]="'footer.url.digital-id' | translate" target="_blank">
           {{ 'footer.digital-id' | translate }} 
        </a>
        <div>
            <a class="footer-link powered-by" [href]="'https://gms.siemens.cloud/'" target="_blank">
                powered by <b>/GMS/</b>
            </a>
        </div>
    </div>
</div>
